import styles from "./textStyles.module.scss";
import scrollbar from "../../../scss/scrollbar.module.scss";
import clsx from "clsx";
import { CARD_TYPES } from "../../../utils/consts";

export default function TextContent(props) {
  const { data, lefty } = props;

  return (
    <div
      className={clsx(
        styles.textContainer,
        scrollbar.scrollbar,
        lefty && styles.leftyAlign,
        data.type !== CARD_TYPES.TEXT && styles.bottomAlign
      )}
    >
      <p className={clsx(styles.cardText, lefty && styles.leftyText)}>
        {data.text}
      </p>
    </div>
  );
}
